(() => {
  const selector = '[data-tksc-auto-grow]';

  const resize = (textarea) => {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((textarea) => {
      if (!textarea.dataset.tkscAutoGrowReady) {
        textarea.dataset.tkscAutoGrowReady = 'true';
        textarea.addEventListener('input', () => resize(textarea));
      }
      resize(textarea);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  window.addEventListener('resize', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
